import React from 'react';
import { CompoundInterestSummaryValue } from '../../value/compound-interest-summary-value';

interface CompoundInterestSummaryFooterMetricProps {
    label: React.ReactNode;
    value: React.ReactNode;
    valueStyle?: React.CSSProperties;
}

export const CompoundInterestSummaryFooterMetric: React.FC<CompoundInterestSummaryFooterMetricProps> = ({
    label,
    value,
    valueStyle,
}) => (
    <div className="flex min-w-0 flex-col gap-[0.8rem] border-t border-[#d9cdc5] p-[2.4rem] first:border-t-0 md:p-[3.2rem] [@media(min-width:1100px)]:border-t-0 [@media(min-width:1100px)]:border-l [@media(min-width:1100px)]:first:border-l-0">
        <div className="mb-[0.8rem] text-[1.4rem] leading-medium font-medium text-web-copy">{label}</div>
        <CompoundInterestSummaryValue
            className="text-[1.8rem] leading-[2.2rem] font-semibold tracking-[-0.02em] text-brand-secondary md:text-[2.2rem] md:leading-[2.6rem]"
            style={valueStyle}
        >
            {value}
        </CompoundInterestSummaryValue>
    </div>
);
